<template>
  <div class="main">
    <div class="c-nav-tabs">
      <ul class="nav-tabs">
        <li class="active">
          <router-link to="/pc/basis">基本信息</router-link>
        </li>
        <li>
          <router-link to="/pc/account">账号信息</router-link>
        </li>
        <li>
          <router-link to="/pc/password">修改密码</router-link>
        </li>
      </ul>
    </div>
    <div class="m-main-wrap navs-tab">
      <div class="c-form pull-relative">
        <div class="c-edit basis" @click="setEnable()" v-if="!isEdit">
          <span class="icon icontemp edit"></span>
          <span class="text">编辑</span>
        </div>
        <div
          class="m-area"
          v-for="o in list"
          :key="o.fieldName"
          :class="{ 'text-shuang': o.displayName.length > 6 }"
        >
          <SText v-if="o.displaySelectType === 'TEXT'" :info="o"></SText>
          <SDatetime
            v-if="o.displaySelectType === 'DATETIME'"
            :info="o"
          ></SDatetime>
          <SRadio v-if="o.displaySelectType === 'RADIO'" :info="o"></SRadio>
          <SCheckbox
            v-if="o.displaySelectType === 'CHECKBOX'"
            :info="o"
          ></SCheckbox>
          <SCheckboxSelect
            v-if="o.displaySelectType === 'CHECKBOXSELECT'"
            :info="o"
          ></SCheckboxSelect>
          <SSelect v-if="o.displaySelectType === 'SELECT'" :info="o"></SSelect>
          <SFile v-if="o.displaySelectType === 'FILE'" :info="o"></SFile>
        </div>
        <div class="form-row t-center" v-if="isEdit">
          <button class="form-btn save u-mr20" @click="save()">保存</button>
          <button class="form-btn cancel" @click="cancel()">取消</button>
        </div>
      </div>
    </div>
<!--    <div class="m-loading-data" v-if="isLoading"></div>-->
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { cr } from "fire-wind-water/core";
import {ck} from "fire-wind-water/cookie";
import { createField, updateDirty } from "../../common/sbase";
import member from "../../services/member";
import { tenantId, schemaId, sess, memberFormId } from "../../common/sbase";

export default {
  name: "Basis",
  data() {
    return {
      list: [],
      isEdit: false,
      value: {},
      isLoading: true
    };
  },
  methods: {
    init() {
      $subscriber.subscribe("s-member-contact", data => {
        this.isLoading = false;
        window.$sk.loading.hide();
        this.value = data[1].fieldInfo;
        this.list = [];
        let avatar = {
          fieldName: "avatar",
          displayName: "头像",
          fieldType: "FILE",
          fileLimitType: "IMG",
          required: "0",
          displayType: "7"
        };
        let schemaFieldInfo = data[0].schemaFieldInfo;
        cr.each(data[0].items, d => {
          if (d.fieldName === "avatar") {
            avatar = d;
            return;
          }
          if (d.fieldName === "password" || d.isLogin == 1) {
            return;
          }
          d.isSensitive = schemaFieldInfo[d.fieldName]
            ? schemaFieldInfo[d.fieldName].isSensitive
            : 0;
          const item = createField(d);
          if (item) {
            item.setDisabled();
            this.list.push(item);
          }
        });
        avatar = createField(avatar);
        avatar.setDisabled();
        this.list.unshift(avatar);
        this.setValue();
      });
      $subscriber.subscribe("s-contact-init", data => {
        this.isLoading = false;
        window.$sk.loading.hide();
        this.value = data.fieldInfo;
        this.setValue();
      });
    },
    setValue() {
      cr.each(this.list, d => {
        if (this.value[d.fieldName]) {
          if (d.fieldType === "FILE") {
            d.initValue(
              this.value[d.fieldName] &&
                (this.value[d.fieldName].newPath ||
                  this.value[d.fieldName].mappingId)
                ? this.value[d.fieldName]
                : null
            );
          } else {
            d.initValue(this.value[d.fieldName] || null);
          }
        }
      });
    },
    setEnable() {
      this.isEdit = true;
      cr.each(this.list, d => {
        d.setEnable();
      });
    },
    save() {
      if (!this.isEdit) {
        return false;
      }
      let isVer = updateDirty(this.list);
      if (isVer.isVerify) {
        this.isEdit = false;
        cr.each(this.list, d => {
          d.setDisabled();
        });
        let info = {
          tenantId: tenantId,
          schemaId: schemaId,
          memberFormId: memberFormId,
          sess: sess,
          globalUserId: decodeURIComponent(ck.cookie("globalUserId")).replaceAll('"', ''),
          formData: isVer.field
        };
        this.isLoading = true;
        member.updateIdentityInfo(info).subscribe(data => {
          if (data.result != 0) {
            this.$message.error(data.desc);
            this.setEnable();
          } else {
            this.$message.success("修改成功");
            $subscriber.emit("s-contact-get");
          }
        });
      }
    },
    cancel() {
      this.isEdit = false;
      cr.each(this.list, d => {
        d.setDisabled();
      });
      this.setValue();
    }
  },
  created() {
    this.init();
  },
  watch: {
    $route: {
      handler: function() {
        this.init();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped></style>
